require('./modules/_all');


const modal = document.getElementById('modal');
const modalImage = document.getElementById('modal-image');
const modalTitle = document.getElementById('modal-title');
const modalRole = document.getElementById('modal-role');
const modalBio = document.getElementById('modal-bio');
const modalEmail = document.getElementById('modal-email');
const modalPhone = document.getElementById('modal-phone');
const modalLinkedIn = document.getElementById('modal-linkedin');
const closeModalButtons = document.querySelectorAll('#close-modal');

/**
 * Function to open the modal with specific content.
 * @param {Object} data - An object containing modal content data.
 */
function openModal(data) {
    if (!modal) return; // safely no-op on pages without modal
    // Populate modal content with data
    modalImage.src = data.image || '/assets/img/dolphin.svg';
    modalImage.alt = data.title || 'Profile Image';
    modalTitle.textContent = data.title || 'Name';
    modalRole.textContent = data.role || '';
    modalBio.textContent = data.bio || 'No bio available.';

    // Set contact links and visibility
    if (data.email) {
        
        modalEmail.href = `mailto:${data.email}`;
        modalEmail.classList.remove('tw-hidden');
    } else {
        console.log(modalEmail);
        modalEmail.classList.add('tw-hidden');
    }

    if (data.phone) {
        modalPhone.href = `tel:${data.phone}`;
        modalPhone.classList.remove('tw-hidden');
    } else {
        modalPhone.classList.add('tw-hidden');
    }

    if (data.linkedin) {
        modalLinkedIn.href = data.linkedin;
        modalLinkedIn.classList.remove('tw-hidden');
    } else {
        modalLinkedIn.classList.add('tw-hidden');
    }

    // Display the modal
    modal.classList.remove('tw-hidden');
    modal.classList.add('tw-flex');

    // Prevent background scrolling when modal is open
    document.body.classList.add('tw-overflow-hidden');
}

/**
 * Function to close the modal.
 */
function closeModalFunc() {
    if (!modal) return;
    modal.classList.remove('tw-flex');
    modal.classList.add('tw-hidden');

    // Restore background scrolling
    document.body.classList.remove('tw-overflow-hidden');
}

/**
 * Attach event listeners to all cards for opening the modal.
 */
const cards = document.querySelectorAll('.cardModal .tw-cursor-pointer[data-title][data-summary]');

cards.forEach(function(card) {
    card.addEventListener('click', function() {
        const title = card.getAttribute('data-title');
        const summary = card.getAttribute('data-summary');
        const image = card.getAttribute('data-image') || '/assets/img/dolphin.svg';
        const bio = card.getAttribute('data-bio') || 'No bio available.';
        const email = card.getAttribute('data-email') || '';
        const phone = card.getAttribute('data-phone') || '';
        const linkedin = card.getAttribute('data-linkedin') || '';
        const role = card.getAttribute('data-role') || '';

        openModal({ title, summary, image, bio, email, phone, linkedin, role });
    });
});

/**
 * Attach event listeners to all close buttons for closing the modal.
 */
closeModalButtons.forEach(function(button) {
    button.addEventListener('click', closeModalFunc);
});

/**
 * Close modal when clicking outside the modal content.
 */
if (modal) {
    modal.addEventListener('click', function(event) {
        if (event.target === modal) {
            closeModalFunc();
        }
    });
}

/**
 * Optional: Close modal with the Esc key.
 */
document.addEventListener('keydown', function(event) {
    if (modal && event.key === 'Escape' && !modal.classList.contains('tw-hidden')) {
        closeModalFunc();
    }
});
